import { reaction } from 'mobx';
import { types as t } from 'mobx-state-tree';

import { storage } from '@utils/browser';

import { withEnv } from 'models/withEnv';

const JobsNextUrls = t.model('JobsNextUrls', {
  published: t.maybeNull(t.string),
  drafts: t.maybeNull(t.string),
  expired: t.maybeNull(t.string),
  archived: t.maybeNull(t.string),
});

const JobsSettings = t
  .model('JobsSettings', {
    chosenTab: 0,
    searchStr: '',
    searchOpen: false,
    nextUrls: t.optional(JobsNextUrls, {}),
  })
  .views(withEnv)
  .views((self) => ({
    get tabDisplay() {
      switch (self.chosenTab) {
        case 0:
          return self.env.t('jobssettings.published');
        case 1:
          return self.env.t('jobssettings.drafts');
        case 2:
          return self.env.t('jobssettings.expired');
        case 3:
          return self.env.t('jobssettings.archived');
        default:
          throw new Error('What happened here?');
      }
    },
    get tabText() {
      switch (self.chosenTab) {
        case 0:
          return 'published';
        case 1:
          return 'drafts';
        case 2:
          return 'expired';
        case 3:
          return 'archived';
        default:
          throw new Error('What happened here?');
      }
    },
  }))
  .actions((self) => ({
    afterCreate() {
      const chosenTab = storage.get('jobs_tab');
      if (chosenTab !== null) {
        self.chosenTab = parseInt(chosenTab, 10);
      }
      reaction(
        () => self.searchStr.length,
        () => {
          self.env.jobStore.load(self.tabText);
        },
        { delay: 400 }
      );
    },
    changeTab(newTab) {
      self.chosenTab = newTab;
      storage.set('jobs_tab', newTab);
    },
    setSearchValue(newValue) {
      self.searchStr = newValue;
    },
    clearSearchValue() {
      self.searchStr = '';
    },
    openSearch() {
      if (!self.searchOpen) {
        self.searchOpen = true;
      }
    },
    closeSearch() {
      if (self.searchOpen) {
        self.searchOpen = false;
      }
    },
    setNextUrl(status, url) {
      self.nextUrls[status] = url;
    },
  }));

const TeamSettings = t
  .model('TeamSettings', {
    chosenTab: 0,
    searchStr: '',
    searchOpen: false,
    sortBy: 'name',
    sortType: 'asc',
  })
  .views(withEnv)
  .views((self) => ({
    get tabs() {
      return [
        { display: self.env.t('user.tabs.all'), value: 0 },
        { display: self.env.t('user.tabs.superadmins'), value: 1 },
        { display: self.env.t('user.tabs.admins'), value: 2 },
        { display: self.env.t('user.tabs.recruiters'), value: 3 },
        { display: self.env.t('user.tabs.limited'), value: 4 },
        { display: self.env.t('user.tabs.employees'), value: 5 },
      ];
    },
  }))
  .actions((self) => ({
    afterCreate() {
      const chosenTab = storage.get('team_tab');
      if (chosenTab !== null) {
        self.chosenTab = parseInt(chosenTab, 10);
      }
    },
    setSorting(val) {
      self.sortType = 'asc';
      self.sortBy = val;
    },
    reverseSort() {
      self.sortType = self.sortType === 'asc' ? 'desc' : 'asc';
    },
    changeTab(newTab) {
      self.chosenTab = newTab;
      storage.set('team_tab', newTab);
    },
    setSearchValue(newValue) {
      self.searchStr = newValue;
    },
    clearSearchValue() {
      self.searchStr = '';
    },
    openSearch() {
      if (!self.searchOpen) {
        self.searchOpen = true;
      }
    },
    closeSearch() {
      if (self.searchOpen) {
        self.searchOpen = false;
      }
    },
  }));

export const CompanyUISettings = t
  .model('CompanyUISettings', {
    jobs: t.optional(JobsSettings, {}),
    team: t.optional(TeamSettings, {}),
    showNotifications: false,
  })
  .actions((self) => ({
    toggleNotifications() {
      self.showNotifications = !self.showNotifications;
    },
    closeNotifications() {
      self.showNotifications = false;
    },
  }));
